
















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import WareHouse from "../../../store/entities/warehouse";
@Component
export default class CreateWareHouse extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  warehouse: WareHouse = new WareHouse();
  idisable:boolean = false;
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  save() {
    (this.$refs.warehouseForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true
        await this.$store.dispatch({
          type: "warehouse/create",
          data:this.warehouse
        });
        (this.$refs.warehouseForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel(){
            (this.$refs.warehouseForm as any).resetFields();
            this.$emit('input',false);
        }
  warehouseRule = {
    ftId: [{ type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wName:[{required: true,message:'请填写库房名称',trigger: 'blur'}],
    number:[{required:true,message:'请填写库房编号',trigger: 'blur'}]
  };
  get factory() {
    return this.$store.state.factory.list;
  }
}
